<template> 
    <form method="POST" :action="route" @submit="checkForm">     
        <input type="hidden" name="_token" :value="token">             
        <input type="hidden" name="contract_id" :value="positions[0].contract.id">   
        <div>
            <table class="myfotable">
                <thead>
                    <tr style="background-color: rgba(38, 42, 62, .05);">                        
                        <th>Name</th>
                        <th>ISIN code</th>
                        <th>Asset class</th>
                        <th>Sector</th>            
                        <th>Risk score</th>
                        <th>Conviction score</th>
                        <th>Last trade date</th>
                        <th>Perf.</th>                 
                        <th>Current weight (%)</th>                        
                        <th>New weight (%) </th>
                    </tr>
                </thead>
                <tbody>                            
                    <tr v-for="(position, index) in pos" :key="index"> 
                        <input type="hidden"
                                :name="'form[' + index + '][id]'"  
                                :value="position.id ">
                        <td>                          
                           <select                                
                                class="form-control"
                                v-model="position.security"                                
                                :disabled="position.id != null">                                    
                                <option value="" disabled>Name</option>
                                <option v-for="secu in secus" :key="secu.id" :value="secu">{{ secu.name }}</option>   
                            </select>   
                               
                            <input type="hidden"
                                :name="'form[' + index + '][security_id]'"  
                                :value="position.security.id ">          
                        </td> 
                        <td>    
                            {{ position.security.isin }}  
                        </td> 
                        <td>
                           {{ position.security.asset_class.name }}
                        </td> 
                        <td>
                           {{ position.security.sector.name }}
                        </td> 
                        <td>
                            <input
                                type="number"
                                class="form-control"      
                                step="1"         
                                min="1"
                                max="5"
                                :name="'form[' + index + '][risk_score]'"                    
                                v-model="position.risk_score">                                
                        </td>
                         <td>
                            <input
                                type="number"
                                class="form-control"      
                                step="1"         
                                min="1"
                                max="3"
                                :name="'form[' + index + '][conviction_score]'"                    
                                v-model="position.conviction_score">      
                        </td>
                        <td>
                           {{ position.last_trade_date }}
                        </td>
                        <td>
                           {{ position.performance }}%
                        </td>
                        <td>
                           {{ position.previous_weight }}
                        </td>    
                        <input type="hidden"
                                :name="'form[' + index + '][previous_weight]'"  
                                :value="position.previous_weight">                
                        <td>
                            <input
                                type="number"
                                class="form-control"     
                                step="0.01"  
                                min="0"
                                max="100"          
                                :name="'form[' + index + '][weight]'"                 
                                v-model.number="position.weight"
                                @change="onPercentageChange">
                        </td>                        
                    </tr>                     
                    <tr>    
                        <td>
                        </td>   
                        <td>
                        </td>
                        <td>
                        </td>  
                        <td>
                        </td>
                        <td>
                        </td>  
                         <td>
                        </td>     
                         <td>
                        </td>
                        <td>
                        </td>
                        <td style="font-weight: 900;">
                            Total
                        </td>                                                  
                        <td style="font-weight: 900;">
                            {{ total_percentage }}
                        </td>                                                   
                    </tr>            
                </tbody>
            </table>
        </div>  
        <div class="container text-center p-5">                       
            <button type="button" class="btn-myfo-blue" v-on:click="addRaw">Add a position</button>    
        </div>  
        
        <div class="row justify-content-center">
            <div class="form-group col-md-4 m-3">
                <label for="proxy" class="fts-14" style="font-weight: 900;">Rational for new trade</label>
                <input type="text" class="form-control" id="proxy" name="proxy" style="height: 200px;">            
            </div>

            <div class="form-group col-md-4 m-3">
                <label for="proxy_rationnal" class="fts-14" style="font-weight: 900;">More general rational</label>
                <input type="text" class="form-control" id="proxy_rationnal" name="proxy_rationnal" style="height: 200px;">            
            </div>
        </div>
                    
        <div class="container text-center p-4">                       
            <button type="submit" class="btn-myfo-green triggerspinner" :disabled="!valid">Update client portfolios</button>            
        </div>   
    </form>   
</template>

<script>
    export default {
        props: [            
            'positions',
            'securities',
            'token',
            'route',           
        ],

        data() {
            return {                                               
                form: [],
                total: 0,
                total_percentage: 0,                
                secus:[],  
                pos: [],
                
                valid: true,       
       
            }           
        },                  

        mounted() {              

            this.securities.forEach(security =>
            {
                this.secus.push(security)
            });
            

            this.positions.forEach(position =>
            {
                this.total += position.amount                
            });
            
            this.positions.forEach(position =>
            {
                this.pos.push(
                {
                    id: position.id,
                    security: this.secus.find(element => element.id == position.security.id),
                    risk_score: position.risk_score,
                    conviction_score: position.conviction_score,                    
                    previous_weight: Math.round(position.amount / this.total * 100 * 100) / 100,
                    last_trade_date: position.last_trade_date,
                    performance: position.performance_position,
                    weight: Math.round(position.amount / this.total * 100 * 100) / 100,                    
                });              
            });

            this.onPercentageChange();            
        },

        methods: {   
            onPercentageChange(){
                this.total_percentage = 0;

                this.pos.forEach(position =>
                {   
                    this.total_percentage += position.weight;
                });    
                this.total_percentage = Math.round(this.total_percentage * 100) / 100;                      
                this.valid = this.total_percentage == 100;
            },

            checkForm(event){
                if (!this.valid)
                {
                    event.preventDefault()
                }            
            },

            addRaw(){
                this.pos.push(
                {        
                    id: null,            
                    security: this.secus[0],
                    risk_score: 1,
                    conviction_score: 1,                    
                    previous_weight: 0,
                    weight: 0,                
                });  
            }
        }
    }    
</script>
